export default __webpack_public_path__ + "static/media/service-offered-bg.2845c5f9.svg";